import { Autocomplete, OutlinedInput, styled } from "@mui/material";
import { ColorSAP, FONT_FAMILY } from "../../ontego-ui";

export const DropdownArrowIcon = styled("div")(() => ({
  position: "absolute",
  right: 16,
  color: ColorSAP.neutral[90],
  width: 24,
  height: 24,
}));

export const CustomOutlinedInput = styled(OutlinedInput)`
    width: 100%;
    background: ${ColorSAP.neutral[10]};
    padding-right: 40px !important;
    border-color: ${ColorSAP.neutral[40]};

    &:hover .MuiOutlinedInput-notchedOutline {
        borderColor: ${ColorSAP.neutral[40]}
    }

    & .Mui-focused .MuiOutlinedInput-notchedOutline {
        border-width: 1px !important;
        border-color: ${ColorSAP.neutral[100]}
    }
        
    & .MuiOutlinedInput-input {
        border: none;
        background: ${ColorSAP.neutral[10]};
        font-family: ${FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR};
        font-size: 14px;
        color: ${ColorSAP.neutral[100]},
        ::placeholder {
            fontFamily: ${FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR}
            font-size: 14px;
            color: ${ColorSAP.neutral[40]} !important;
            opacity: 1;
        },
    }

    & .MuiOutlinedInput-notchedOutline {
        border-color: ${ColorSAP.neutral[40]};
    }

    & .Mui-focused {
        border: none;
    }
`